import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { toast } from "sonner";
import { AlertTriangle, Gift, Loader2 } from "lucide-react";

export const KEINE_RECHNUNG = "Keine Rechnung – Auftragssumme 0,00 €";
export const CRM_HINWEIS = "Wird im CRM erstellt (sevDesk unterstützt keine 0-€-Belege)";

// Badge am Auftrag: Gesamtbetrag 0,00 € (Goodie/Muster) → CRM-Angebot, keine Zahlung, keine Rechnung
export const KostenlosBadge = ({ order }) => {
  if (!order?.kostenlos) return null;
  return (
    <span className="text-xs px-2 py-0.5 rounded border bg-emerald-50 text-emerald-700 border-emerald-200 inline-flex items-center gap-1"
      title={`${CRM_HINWEIS}. Keine Zahlung und keine Rechnung.`} data-testid="auftrag-kostenlos-badge">
      <Gift className="w-3 h-3" /> Kostenlos (0,00 €){order.kostenlos_angebot_nummer ? ` · ${order.kostenlos_angebot_nummer}` : ""}
    </span>
  );
};

// Übergang: vorhandenes sevDesk-Angebot, Auftrag ist jetzt 0,00 € → ablehnen (Status 300) und CRM-Angebot verwenden
export const KostenlosSevdeskWarnung = ({ order, canAct, onUpdated }) => {
  const [busy, setBusy] = useState(false);
  if (!order?.kostenlos || !order.sevdesk_angebot_id || order.price_locked) return null;
  const run = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/auftraege/${order.id}/kostenlos/sevdesk-angebot-ablehnen`);
      toast.success("sevDesk-Angebot abgelehnt – bei der Preisfreigabe wird das CRM-Angebot verwendet.");
      onUpdated(r.data);
    } catch (e) { toast.error(e?.response?.data?.detail || "sevDesk-Angebot konnte nicht abgelehnt werden."); }
    finally { setBusy(false); }
  };
  return (
    <Card className="border-amber-300 bg-amber-50" data-testid="kostenlos-sevdesk-warnung">
      <CardContent className="p-4 flex items-start gap-3 flex-wrap">
        <AlertTriangle className="w-5 h-5 text-amber-700 shrink-0 mt-0.5" />
        <div className="flex-1 min-w-[240px] text-sm text-amber-900">
          <div className="font-semibold">Auftragssumme 0,00 € – sevDesk-Angebot {order.sevdesk_angebot_nummer || order.sevdesk_angebot_id} passt nicht mehr</div>
          <div>sevDesk unterstützt keine 0-€-Belege. Das vorhandene Angebot wird nicht mehr aktualisiert; für die Preisfreigabe wird ein CRM-Angebot erstellt.</div>
        </div>
        {canAct && (
          <Button size="sm" variant="outline" onClick={run} disabled={busy} className="border-amber-400 bg-white" data-testid="kostenlos-sevdesk-ablehnen">
            {busy && <Loader2 className="w-4 h-4 mr-1 animate-spin" />} sevDesk-Angebot ablehnen (Status 300) und CRM-Angebot verwenden
          </Button>
        )}
      </CardContent>
    </Card>
  );
};
